import { Store } from '@tanstack/react-store';

export type confirmerStoreType = {
    isOpen: boolean;
    title: string;
    isDanger?: boolean;
    resolve?: (value: boolean) => void;
};
export const confirmerStore = new Store<confirmerStoreType>({
    isOpen: false,
    title: '',
    isDanger: false,
});

export function showConfirm(title?: string, isDanger?: boolean): Promise<boolean> {
    return new Promise((resolve) => {
        confirmerStore.setState(() => ({
            isOpen: true,
            title: title || 'Er zijn niet-opgeslagen wijzigingen.\nWeet je zeker dat je wilt sluiten?',
            isDanger,
            resolve,
        }));
    });
}

export function handleConfirm(confirmed: boolean) {
    const { resolve } = confirmerStore.state;
    if (resolve) {
        resolve(confirmed);
    }
    confirmerStore.setState(() => ({ isOpen: false, title: '', resolve: undefined }));
}
